import React from 'react';
import './Loader.css'; // Import CSS for styling the loader

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading...</p>
        </div>
    );
};

export default Loader;